import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { Globals } from 'projects/core/src/globals';
import { WSService } from 'projects/core/src/include/service'
import { Notification, ToastMode } from 'projects/core/src/include/structures';
import { PreviewnotificationComponent } from '../common/notifications/previewnotification/previewnotification.component';
import { Address } from 'projects/c1-backend/src/app/db/address';
import { AddressesService } from 'projects/c1-backend/src/app/services/addresses.service';


@Injectable({
  providedIn: 'root'
})
export class NotificationService extends WSService<Notification> {

  constructor() { super("notifications") };

  getNotifications(table:string,id_record:number=0):Observable<Notification[]>{
    return  Globals.ws.requestUrl<Notification[]>("notifications","getNotifications",[table,id_record.toString()]);
    
  }

  getAllNotifications():Observable<Notification[]>{
    return  Globals.ws.requestUrl<Notification[]>("notifications","getItems",[]);
    
  }


  prepareNotify(item:Notification,id_address:number,addressItem:Address=null){
    item['id_address']=id_address;
    let timerConnection=null;
    let sended=false;
    let sended_whatsapp=false;
    let enable_sms_c1connector=Globals.parameters.get("notifications").getParam("sms_c1connector",false);
    let enable_whatsapp_c1connector=Globals.parameters.get("notifications").getParam("whatsapp_c1connector",false);
  

    if(enable_sms_c1connector){
      var subscription_sms=Globals.c1connector.onMessageReceived.subscribe((result)=>{
        if(result['cmd']=="sms_sended"){
          Globals.loading=false;
          //if(result['status']){
            Globals.message.showToaster("SMS inviato correttamente al numero "+result['number'],ToastMode.SUCCESS);
          /*}else{
            Globals.message.showToaster("Errore nell'invio SMS\n"+result['error'],ToastMode.DANGER);
  
          }*/
          subscription_sms.unsubscribe();
          if(timerConnection!=null)
            clearTimeout(timerConnection);
          sended=true;
        
        }
      });
      var subscription_whatsapp=Globals.c1connector.onMessageReceived.subscribe((result)=>{
    

        if(result['cmd']=="whatsapp_sended"){
          Globals.loading=false;
          if(result['status']){
            Globals.message.showToaster("Messaggio WhatsApp inviato correttamente al numero "+result['number'],ToastMode.SUCCESS);
          }else{
            Globals.message.showToaster("Errore nell'invio del messaggio WhatsApp\n"+result['error'],ToastMode.DANGER);
  
          }
          subscription_whatsapp.unsubscribe();
          if(timerConnection!=null)
            clearTimeout(timerConnection);
            sended_whatsapp=true;
        
        }


      });
    }

    //trova il gateway di invio sms
    
    for(let i=0;i<item.gateways.length;i++){
    //item.gateways.forEach(element => {


      if(addressItem!=null){
         for(let c of addressItem.contacts){
          if(c.id_type==item.gateways[i].id_type)
            item.gateways[i]['contact']=c.value;
         }

         if(item.gateways[i].gateway=="app"){
          item.gateways[i]['contact']=addressItem.id_user;
         }

      }
      /*
      if(element.gateway=="sms" && enable_sms_c1connector && element.enable){
        var m={};
        m['cmd']="sendSMS";
        m['type']="smsgateway";
        var s={};
        s['id_user']=Globals.user.id;
        s['id_address']=item['id_address'];
        s['number']=element['contact'];
        try{
          let message=JSON.parse(element['message']);
          s['message']=message['body'];
        }catch{
          s['message']="";
        }

        
        m['value']=s;

        //verifica che il c1connector sia connesso


        if(Globals.c1connector.connected){
          Globals.c1connector.sendMessage(m);
          Globals.loading=true;

          timerConnection=setTimeout(()=>{
            if(!sended){
              Globals.loading=false;
              Globals.message.showToaster("Il server SMS ci mette troppo tempo. Controllare che sia attivo",ToastMode.DANGER);
            }
            if(timerConnection!=null)
            clearTimeout(timerConnection);
          
          },10000)


          //exit;
        }
      }

      if(element.gateway=="whatsapp" && enable_whatsapp_c1connector && element.enable){
        var m={};
        m['cmd']="sendWhatsappMessage";
        m['type']="whatsapp";
        var s={};
        s['id_user']=Globals.user.id;
        s['id_address']=item['id_address'];
        s['number']=element['contact'];
        try{
          let message=JSON.parse(element['message']);
          s['message']=message['body'];
        }catch{
          s['message']="";
        }

        
        m['value']=s;

        //verifica che il c1connector sia connesso


        if(Globals.c1connector.connected){
          Globals.c1connector.sendMessage(m);
          Globals.loading=true;

          timerConnection=setTimeout(()=>{
            if(!sended_whatsapp){
              Globals.loading=false;
              Globals.message.showToaster("Il server WhatsApp ci mette troppo tempo. Controllare che sia attivo",ToastMode.DANGER);
            }
            if(timerConnection!=null)
            clearTimeout(timerConnection);
          
          },20000)


          //exit;
        }
      }*/


    }
    if(id_address)
      item['id_address']=id_address;



    return item;
  }

  sendNotify(item:Notification,id_address:any,onComplete:Function,addresses:Address[]=[]){
    

    if(Array.isArray(id_address)){
      let items=[];
      for(let i=0;i<addresses.length;i++){
        let notify:Notification=JSON.parse(JSON.stringify(item));
        items.push(this.prepareNotify(notify,addresses[i].id,addresses[i]));
      }

      var item2send:any=items;
      if(Globals.ws.api_version=="v2"){
        item2send={"values":items};
      }

      return Globals.ws.send(this.table,"sendMultiple",item2send,[],(result:string)=>{
          let objs=result;
          
          
          let count={
            email:{
              count:0,
              confimed:0
            },
            sms:{
              count:0,
              confimed:0
            },
            c1app:{
              count:0,
              confimed:0
            },
            whatsapp:{
              count:0,
              confimed:0
            }
          }
          

          for(let obj of objs){
            if(obj['email']) count.email.count++;
            if(obj['sms']) count.sms.count++;
            if(obj['c1app']) count.c1app.count++;
            if(obj['whatsapp']) count.whatsapp.count++;
          }


          let message="Email inviate: "+count.email.count+"<br/>";
          message+="SMS inviati: "+count.sms.count+"<br/>";
          message+="WhatsApp inviati: "+count.whatsapp.count+"<br/>";
          message+="Notifiche app inviati: "+count.c1app.count+"<br/>";
          

          Globals.message.showToaster(message,ToastMode.SUCCESS);

      });



    }else{

      const addressesService:AddressesService=new AddressesService();

      addressesService.getItem(id_address).subscribe((address)=>{

      
        const item_prepared=this.prepareNotify(item,id_address,address);

        var item2send:any=item_prepared;
        if(Globals.ws.api_version=="v2"){
          item2send={"values":item_prepared};
        }

        return Globals.ws.send(this.table,"send",item2send,[],(result:string)=>{
          let obj=result;
        
          if(obj['email']){
            Globals.message.showToaster("Email inviata correttamente",ToastMode.SUCCESS);
          }

          if(obj['sms']){
            Globals.message.showToaster("SMS inviato correttamente",ToastMode.SUCCESS);
          }
          

          if(obj['whatsapp']){
            Globals.message.showToaster("whatsapp inviato correttamente",ToastMode.SUCCESS);
          }
        });
      })
    }

    
  }

  
  showPreviewNotification(contacts:any,record:any,table:string,oncomplete:Function,id_address:any=0,id_notification=0,addresses:Address[]=[]){
    let multipleContact=false;
    //verifica se è un invio multiplo
    if(Array.isArray(id_address))
      multipleContact=true;

    Globals.modal.showModal(PreviewnotificationComponent,[
      {"name":"table","value":table},
      {"name":"contacts","value":contacts},
      {"name":"record","value":record},
      {"name":"id_notification","value":id_notification},
      {"name":"multipleContact","value":multipleContact},
      {"name":"addresses","value":addresses}
    ],(instance)=>{
      
      if(instance!=null){
        let notify=instance['selectedNotify'];

        let id_address_to_send=id_address;
        if(Array.isArray(id_address)){

        }else{
          if(id_address>0)
            id_address_to_send=id_address
          else
            id_address_to_send=record.id
        }


        this.sendNotify(notify,id_address_to_send,(id)=>{
          
          //verifica se i contatti sono da aggiungere

          oncomplete(id);
          
        },addresses);
      }
    },"lg");
  }
  

}
